import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

import { mapViewSettings } from './mapViewSettings';

const getNetworkEventsRoutesFO = ({ currentUser }) => ({
  events_path: (params) => Routes.user_events_path(currentUser.id, params),
  markers_path: (params) => Routes.markers_v2_events_path(params),
});

const getNetworkEventsRoutesPO = () => ({
  events_path: (params) => Routes.network_events_path(params),
  markers_path: (params) => Routes.markers_v2_po_events_path(params),
});

const getTopicEventsRoutesFO = ({ topicId }) => ({
  events_path: (params) => Routes.topics_topic_events_path(topicId, params),

  markers_path: (params) =>
    Routes.markers_v2_topics_topic_events_path(topicId, params),
});

const getTopicEventsRoutesPO = ({ topicId, topicContext }) => ({
  events_path: (params) =>
    dynamicTopicResourcePath(
      Routes.topic_publicoffice_topics_events_path(topicId, {
        ...params,
        format: 'json',
      }),
      topicContext,
    ),
  markers_path: (params) =>
    dynamicTopicResourcePath(
      Routes.topic_publicoffice_topics_events_markers_v2_path(topicId, params),
      topicContext,
    ),
});

const getRoutes = (type, params) => {
  const { currentUser } = params;

  switch (type) {
    case 'group': {
      return currentUser
        ? getTopicEventsRoutesFO(params)
        : getTopicEventsRoutesPO(params);
    }
    default: {
      return currentUser
        ? getNetworkEventsRoutesFO(params)
        : getNetworkEventsRoutesPO();
    }
  }
};

const getEventsIndexConfig = (type, params, appPageConfig) => {
  const { topicId, currentUser, featuresConfig, location } = params;
  const routes = getRoutes(type, params);

  return {
    topicId,
    routes: {
      user_event_path: (userId, eventId) =>
        Routes.user_event_path(userId, eventId),
      ...routes,
    },
    eventCalendarViewEnabled:
      featuresConfig?.events?.config?.event_calendar_view_enabled,
    mapViewSettings: mapViewSettings({
      configs: featuresConfig?.events?.config,
      currentUser,
      location,
    }),
    appPageConfig,
  };
};

export default getEventsIndexConfig;
